import { render, staticRenderFns } from "./GamesBlockWithWinnersList.vue?vue&type=template&id=990c151c&scoped=true&"
import script from "./GamesBlockWithWinnersList.vue?vue&type=script&lang=js&"
export * from "./GamesBlockWithWinnersList.vue?vue&type=script&lang=js&"
import style0 from "./GamesBlockWithWinnersList.vue?vue&type=style&index=0&id=990c151c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990c151c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/betsur.net.ar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('990c151c')) {
      api.createRecord('990c151c', component.options)
    } else {
      api.reload('990c151c', component.options)
    }
    module.hot.accept("./GamesBlockWithWinnersList.vue?vue&type=template&id=990c151c&scoped=true&", function () {
      api.rerender('990c151c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/games/GamesBlockWithWinnersList.vue"
export default component.exports